import React, { Component, Fragment } from "react";
class GridGuidelines extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };

    }
    render() {
        const gridGutterWidth = !this.props.gridGuideGutterSpace ? 2 : Number(this.props.gridGuideGutterSpace);
        const gridColumnCount = !this.props.gridGuideColumns ? 12 : Number(this.props.gridGuideColumns);
        const gridGuideLineColor = this.props.gridGuideLineColor ?
            `rgba(${this.props.gridGuideLineColor.r},
            ${this.props.gridGuideLineColor.g},
            ${this.props.gridGuideLineColor.b},
            ${this.props.gridGuideLineColor.a})` : `rgba(38, 169, 225, 0.25)`
        // Grid Overlay

        const gutterWidth = (gridGutterWidth / 2) + `px`;
        const columnWidth = (1 / gridColumnCount) * 100;

        const style =
            this.props.mobileView == true
                ? {
                    border: "1px dashed #26a9e1",
                    width: '100%',
                    backgroundColor: "rgb(223, 243, 225)",
                    height: "100vh",
                }
                : {
                    width: '100%',
                    height: "100vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                };
        return (
            <Fragment>
                <div className={`gridLines ${this.props.mobileView == true ? 'mobileView' : ''}`} style={style}>
                    {this.props.children}
                </div>
            </Fragment>
        );
    }
}
export default GridGuidelines;